
import { Component, Vue } from "vue-property-decorator";
import AppInfo from "./appInfo/AppInfo.vue";
import AppVersions from "./appVersions/AppVersions.vue";
import DownloadChart from "./downloadChart/DownloadChart.vue";
import UserGroup from "./userGroup/UserGroup.vue";
import { getItemUserGroupList } from "@/api/grayRelease";

type IUserGroup = IResponse.GrayRelease.IUserGroup;

@Component({
  components: {
    AppInfo,
    AppVersions,
    DownloadChart,
    UserGroup,
  },
})
export default class AppDetail extends Vue {
  public $refs!: {
    AppVersionsRef: AppVersions;
  };
  public userGroupList: IUserGroup[] = [];

  public created() {
    this.initUserGroupList();
  }

  public refresh(): void {
    this.$refs.AppVersionsRef.initVersions();
  }
  public toBack(): void {
    this.$router.go(-1);
  }
  public async initUserGroupList() {
    const id = this.$route.query.id as string;
    const response = await getItemUserGroupList(id);
    if (!response.status) {
      this.$message.error(response.message);
      return;
    }
    this.userGroupList = response.data;
  }
}
